import React from 'react';

import CustomComponent from '../CustomComponent';

import { convertStyleData } from '@utils/tools';
import { appMethod as app } from '@utils/app';

import './PopupWindowCustomComponent.less';

export default class PopupWindowCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance, isPullRefresh) => {
    if(isPullRefresh){
      return;
    }
    this.controlAutoPopupWindow(compindex, pageInstance);
  }

  controlAutoPopupWindow = (compindex, pageInstance) => {
    let _this = this;
    let newData = {};
    let compData = pageInstance.data.eles[compindex];
    let customFeature = compData.customFeature;

    // TODO: webapp暂无顶部导航,暂不支持,先注释
    // let topnav = pageInstance.data['custom_top_nav1'];
    // if (topnav && topnav.customFeature.isDefault == 1 && !compData.styleInit){
    //   let top = compData.style.match(/margin-top:(\-?([\d|\.]*))rpx;/);
    //   if(top){
    //     let systeminfo = app.getSystemInfoData();
    //     let rpxRatio = systeminfo.rpxRatio || 2.34375;
    //     let mtop = "margin-top:" + (+top[1] + (app.globalData.topNavBarHeight || 0) * rpxRatio) + "rpx;";
    //     let style = compData.style.replace(top[0], mtop);
    //     newData['eles[' + compindex + '].style'] = style;
    //     newData['eles[' + compindex + '].styleInit'] = true;
    //   }
    // }

    if (customFeature.autoPopup === true) {
      if (customFeature.popupScene === 'everyDay' || customFeature.popupScene === 'firstAuthorize'){
        // 获取用户是否为第一次授权、是否为当天第一次登录
        if (!app.globalData.firstLoginAppChecked) {
          app.sendRequest({
            hideLoading: true,
            url: '/index.php?r=AppData/CheckFirstLoginApp',
            success: function(data){
              app.globalData.firstAuthorize = data.data.isAppFirstLogin;
              app.globalData.dailyFirstLogin = data.data.isDailyFirstLogin;
              app.globalData.firstLoginAppChecked = true;
              _this.controlAutoPopupWindow(compindex, pageInstance);
            }
          })
          return;
        }
        if((app.globalData.firstAuthorize && customFeature.popupScene === 'firstAuthorize') || (app.globalData.dailyFirstLogin && customFeature.popupScene === 'everyDay')){
          if(!pageInstance.data.eles[compindex].alreadyShown){
            newData['eles[' + compindex + '].showPopupWindow'] = true;
            newData['eles[' + compindex + '].alreadyShown'] = true;
            pageInstance.setData(newData);
          }
        }

      } else if (customFeature.popupScene === 'everyTime'){
        newData['eles[' + compindex + '].showPopupWindow'] = true;
        pageInstance.setData(newData);
      }

      if(customFeature.autoClose === true){
        setTimeout(()=>{
          newData['eles[' + compindex + '].showPopupWindow'] = false;
          pageInstance.setData(newData);
        }, +customFeature.closeDelay*1000);
      }
    }
    
  }

  tapMaskClosePopupWindow = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let compdata = pageInstance.data.eles[compindex];
    let newData = {};
    if(compdata.customFeature.tapMaskClose === true){
      newData['eles[' + compindex + '].showPopupWindow'] = false;
      pageInstance.setData(newData);
    }
  }

  render() {
    /**
     * 传入数据
     */ 
    const data = this.props.data;                // 组件数据
    const detailData = this.props.detailData;    // 详情页数据
    const dynamicData = this.props.dynamicData;  // 动态数据
    /**
     * 组件配置对象
     */  
    const customFeature = data.customFeature;
    /**
     * 样式数据处理
     */
    const styleObj = convertStyleData(data.style);
    const maskStyleObj = {
      backgroundColor: customFeature.maskBackgroundColor,
      opacity: customFeature.maskOpacity,
    }
    /**
     * 组件内容处理
     */   
    let content = data.content;
    const segment = data.customFeature.segment; // 已绑定字段
    // 是否有绑定字段
    if (segment) {
      if (detailData && detailData[segment]) {
        content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
      } else if (dynamicData && dynamicData[segment]) {
        content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
      }
    }
    /**
     * 返回组件
     */
    if (!data.showPopupWindow) {
      return null;
    }
    return (
      <div className="custom-component popup-window" >
        <div className="popup-window-mask" style={maskStyleObj} onClick={this.tapMaskClosePopupWindow} data-compindex={this.props.index}></div>
        <div className="popup-window-content" style={styleObj}>
          {content.map((componentData, componentIndex) => 
            <CustomComponent key={componentIndex} index={componentIndex} data={componentData} detailData={detailData} dynamicData={dynamicData}/>
          )}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/custom-component/popup-window-custom-component/PopupWindowCustomComponent.jsx